////////LIBRARY/////////
import update from 'immutability-helper'
import { isUndefined, cloneDeep, map } from 'lodash'
///////COMPONENTS///////
import extendUpdate from '../../helpers/extendUpdate'
import ActionsTypes from '../../constants/ActionsTypes'

extendUpdate(update)

const itemCatalog = {
	[ActionsTypes.RESET_DATA_ITEM_CATALOG]: (state) => {
		return update(state, {
			itemCatalog: {
				items: {
					$set: [],
				},
			},
		})
	},

	[ActionsTypes.GET_ITEM_CATALOG]: (state) =>
		update(state, {
			itemCatalog: {
				isLoading: {
					$set: true,
				},
				error: {
					$set: false,
				},
				items: {
					$set: [],
				},
			},
			columns: {
				isSearchfieldUpdated: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.GET_ITEM_CATALOG_SUCCESS]: (state, payload) => {
		const paging = {
			totalElements: payload.data.headerContent.contentPagined.totalElements,
			totalPages: payload.data.headerContent.contentPagined.totalPages,
		}

		// Separate manufacturer kiosk from customer kiosk filters
		let filters = cloneDeep(payload.data.headerParam.filters)
		let filtersSelection = cloneDeep(payload.data.headerParam.filters.filtersSelection)
		if (!isUndefined(filtersSelection)) {
			filtersSelection.customerKiosks = cloneDeep(filtersSelection.kiosks)
			// Much more simplier, just duplicating list, and not using the same field as label
			/*filtersSelection.customerKiosks.filterElements = filter(
				payload.data.headerParam.filters.filtersSelection?.kiosks.filterElements,
				(o) => !isNull(o.customerKioskCode)
			)*/
			/*filtersSelection.kiosks.filterElements = filter(payload.data.headerParam.filters.filtersSelection?.kiosks.filterElements, (o) =>
				isNull(o.customerKioskCode)
			)*/
			filters.filtersSelection = filtersSelection

			// Setting values on label attribute
			map(filters.filtersSelection.customerKiosks.filterElements, (elem) => {
				elem.label = elem.customerKioskCode
				return elem
			})

			// Setting values on label attribute
			map(filters.filtersSelection.kiosks.filterElements, (elem) => {
				elem.label = elem.manufacturerKioskCode
				return elem
			})
		}

		return update(state, {
			itemCatalog: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				items: {
					$set: payload.data.headerContent.contentPagined.content,
				},
				paging: {
					$set: paging,
				},
				header: {
					$set: filters,
				},
			},
		})
	},
	[ActionsTypes.GET_ITEM_CATALOG_FAILURE]: (state, payload) => {
		return update(state, {
			itemCatalog: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		})
	},
	[ActionsTypes.SET_ITEM_CATALOG_SALESBYCODE]: (state, payload) => {
		return update(state, {
			salesHistoryByCodes: {
				itemCatalog: {
					$set: payload.itemCatalog,
				},
			},
		})
	},
	[ActionsTypes.GET_ITEM_CATALOG_FILTERS_STOCKS]: (state, payload) => {
		return update(state, {
			recapStock: {
				filtersInfos: {
					$set: payload.filtersInfos,
				},
			},
		})
	},
	[ActionsTypes.SET_ITEM_CATALOG_SALEBYARTICLE]: (state, payload) => {
		return update(state, {
			salesByArticleHistoryManager: {
				itemCatalog: {
					$set: payload.itemCatalog,
				},
			},
		})
	},
	[ActionsTypes.GET_SALE_ORDER_BY_CODE]: (state, _payload) => {
		return update(state, {
			itemCatalog: {
				/* isLoading: {
					$set: true
				}, */
				error: {
					$set: false,
				},
				item: {
					$set: [],
				},
				itemGenerateCode: {
					$set: [],
				},
			},
		})
	},
	[ActionsTypes.GET_SALE_ORDER_BY_CODE_SUCCESS]: (state, payload) => {
		return update(state, {
			itemCatalog: {
				item: {
					$set: payload,
				},
				/* isLoading: {
					$set: false
				} */
			},
		})
	},
	[ActionsTypes.GET_SALE_ORDER_BY_CODE_FAILURE]: (state, payload) => {
		return update(state, {
			itemCatalog: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		})
	},
	[ActionsTypes.POST_CREATE_CODE]: (state, _payload) => {
		return update(state, {
			itemCatalog: {
				isLoading: {
					$set: true,
				},
				error: {
					$set: false,
				},
				itemGenerateCode: {
					$set: [],
				},
			},
		})
	},
	[ActionsTypes.POST_CREATE_CODE_SUCCESS]: (state, payload) => {
		return update(state, {
			itemCatalog: {
				itemGenerateCode: {
					$set: payload,
				},
				isLoading: {
					$set: false,
				},
			},
		})
	},
	[ActionsTypes.POST_CREATE_CODE_FAILURE]: (state, payload) => {
		return update(state, {
			itemCatalog: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		})
	},

	[ActionsTypes.POST_SEND_CODE]: (state, _payload) => {
		return update(state, {
			itemCatalog: {
				isLoading: {
					$set: true,
				},
				error: {
					$set: false,
				},
				itemGenerateCode: {
					$set: [],
				},
			},
		})
	},
	[ActionsTypes.POST_SEND_CODE_SUCCESS]: (state, _payload) => {
		return update(state, {
			itemCatalog: {
				isLoading: {
					$set: false,
				},
			},
		})
	},
	[ActionsTypes.POST_SEND_CODE_FAILURE]: (state, payload) => {
		return update(state, {
			itemCatalog: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		})
	},
	[ActionsTypes.SET_IS_CLOSED_MODAL]: (state, _payload) => {
		return update(state, {
			itemCatalog: {
				isClosedModal: {
					$set: true,
				},
			},
		})
	},
	[ActionsTypes.SET_IS_TO_UPDATE]: (state, _payload) => {
		return update(state, {
			itemCatalog: {
				toUpdated: {
					$set: true,
				},
			},
		})
	},
}

export default itemCatalog
